class ShopTheCollection extends HTMLElement {
  connectedCallback() {
    this._cards   = [...this.querySelectorAll('[data-card]')];
    this._priceEl = this.querySelector('[data-total-price]');
    this._compareEl = this.querySelector('[data-total-compare]');
    this._btn     = this.querySelector('[data-add-btn]');

    this._cards.forEach(card => {
      if (card.hasAttribute('data-fixed')) return;
      card.addEventListener('click', () => this._toggle(card));
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._toggle(card); }
      });
    });

    if (this._btn) this._btn.addEventListener('click', () => this._addToCart());
    this._updateUI();
  }

  _toggle(card) {
    const active = card.classList.toggle('shop-the-collection__card--active');
    card.setAttribute('aria-pressed', String(active));
    this._updateUI();
  }

  _updateUI() {
    let price = 0, compare = 0, count = 0;

    this._cards.forEach(card => {
      if (!card.classList.contains('shop-the-collection__card--active')) return;
      price   += parseInt(card.dataset.price   || 0, 10);
      const c  = parseInt(card.dataset.compare || 0, 10);
      compare += c > 0 ? c : parseInt(card.dataset.price || 0, 10);
      count++;
    });

    if (this._priceEl)   this._priceEl.textContent = this._money(price);
    if (this._compareEl) {
      if (compare > price) {
        this._compareEl.textContent = this._money(compare);
        this._compareEl.hidden = false;
      } else {
        this._compareEl.hidden = true;
      }
    }

    if (this._btn) {
      this._btn.disabled = count === 0;
      this._btn.textContent = count === 0
        ? 'Select items to add'
        : `Add ${count} Item${count !== 1 ? 's' : ''} to Cart`;
    }
  }

  _money(cents) {
    const n = Math.round(cents) / 100;
    return '$' + (n % 1 === 0 ? n : n.toFixed(2));
  }

  async _addToCart() {
    const items = this._cards
      .filter(c => c.classList.contains('shop-the-collection__card--active'))
      .map(c => ({ id: parseInt(c.dataset.variantId, 10), quantity: 1 }));

    if (!items.length) return;

    const original = this._btn.textContent;
    this._btn.disabled = true;
    this._btn.textContent = 'Adding…';

    try {
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map(el => el.dataset.sectionId)
        .filter(Boolean);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds })
      });

      if (!res.ok) throw new Error(res.statusText);

      const data = await res.json();

      this._btn.textContent = '✓ Added to Cart';

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            sections: data.sections,
            source: 'shop-the-collection',
            itemCount: items.length,
          }
        }
      }));

      setTimeout(() => { this._btn.disabled = false; this._updateUI(); }, 2000);
    } catch {
      this._btn.textContent = 'Error — try again';
      this._btn.disabled = false;
      setTimeout(() => { this._btn.textContent = original; }, 2500);
    }
  }
}

customElements.define('shop-the-collection', ShopTheCollection);

document.addEventListener('variant-picker:updated', function () {
  document.querySelectorAll('shop-the-collection').forEach(function (el) {
    el.connectedCallback();
  });
});
